module.exports = __webpack_public_path__ + "static/media/hezuoBuss.4b3c0aa4.svg";